$(function(){
	var originalAddClassMethod = jQuery.fn.addClass;
	var originalRemoveClassMethod = jQuery.fn.removeClass;
	var originalToggleClassMethod = jQuery.fn.toggleClass;

	jQuery.fn.addClass = function () {
		var result = originalAddClassMethod.apply(this, arguments);
		jQuery(this).trigger('cssClassAdded');
		jQuery(this).trigger('cssClassChanged');
		return result;
	}

	jQuery.fn.removeClass = function () {
		var result = originalRemoveClassMethod.apply(this, arguments);
		jQuery(this).trigger('cssClassRemoved');
		jQuery(this).trigger('cssClassChanged');
		return result;
	}

	jQuery.fn.toggleClass = function () {
		var result = originalToggleClassMethod.apply(this, arguments);
		jQuery(this).trigger('cssClassToggled');
		jQuery(this).trigger('cssClassChanged');
		return result;
	}
})